import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconPhone = (props: IconProps) => (
  <svg
    className={cn(iconStyles(props))}
    width="23"
    height="23"
    viewBox="0 0 23 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4.462c-.047 4.24 1.905 8.64 5.373 12.103l.077.077C9.86 20.045 14.23 22 18.435 22l.141-.002c.306-.246.597-.505.868-.773a11.051 11.051 0 0 0 2.503-3.844c.068-.17.132-.612-.226-.84-1.67-.747-3.03-1.184-5.327-1.694-.504-.079-.64.084-.721.142l-.666 1.397c-.496.803-1.864.898-2.854.173A26.978 26.978 0 0 1 9.12 13.98a27.977 27.977 0 0 1-2.6-3.038c-.422-.578-.597-1.256-.478-1.858.085-.432.318-.785.66-.996 0 0 1.236-.654 1.381-.781.146-.127.204-.333.09-.66-.5-1.89-1.202-3.894-1.755-5.427-.03-.006-.058-.394-.789-.128-.73.266-2.753 1.405-3.855 2.504-.261.262-.516.546-.773.865z"
      strokeWidth="1.8"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
